<template>
  <div :class="[baseCss, toolbar ? 'relative' : null, disabled ? ['disabled', 'pointer-events-none', 'select-none'] : null]">
    <div @blur="onBlur" @mousedown="onEdit" @dblclick="onEdit" :spellcheck="spellCheck" :contenteditable="contentEditable" :class="[`${baseCss}-contenteditable`, 'outline-none', transition, contentEditable ? [`ring-${outlineWidth}`, `ring-${color}${colorLightness ? '-' + colorLightness : ''}`] : null]"><slot /></div>
    <card v-if="toolbar" :bg-color="color" :bg-color-lightness="colorLightness" :class="[contentEditable ? 'opacity-100' : 'opacity-0', transition, 'absolute', `mt-${outlineWidth}`, `${toolbarPosition}-0`]">
      <card-actions padding-off :class="['p-1']">
        <container :class="['whitespace-nowrap']">
          <icon :color="toolbarButtonsColor" :color-lightness="toolbarButtonsColorLightness" :size="1.25" @click="onCancel" name="close" :class="['mx-1', 'cursor-pointer']" /><!--
          --><icon :color="toolbarButtonsColor" :color-lightness="toolbarButtonsColorLightness" :size="1.25" @click="onOk" name="check" :class="['mx-1', 'cursor-pointer']" />
        </container>
      </card-actions>
    </card>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'InlineEditor',
  mixins: [
    methods
  ],
  data () {
    return {
      content: null,
      contentEditable: false,
      transition: ['transition-all', 'duration-250'],
      baseCss: this.componentBaseCss('inline-editor', [])
    }
  },
  watch: {
    contentEditable () {
      if (this.contentEditable) {
        this.content = this.getContent()
      }
    }
  },
  props: {
    editOn: {
      type: String,
      default: 'mousedown',
      validator: value => {
        return ['mousedown', 'dblclick'].includes(value)
      }
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    spellCheck: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Boolean
    },
    toolbarPosition: {
      type: String,
      default: 'right',
      validator: value => {
        return ['left', 'right'].includes(value)
      }
    },
    toolbarButtonsColor: {
      type: String,
      default: 'white'
    },
    toolbarButtonsColorLightness: {
      type: Number,
      default: null
    },
    outlineWidth: {
      type: Number,
      default: 1,
      validator: value => {
        return [0, 1, 2].includes(value)
      }
    },
    color: {
      type: String,
      default: 'gray'
    },
    colorLightness: {
      type: Number,
      default: 500,
      validator: value => {
        return [50, 100, 200, 300, 400, 500, 600, 700, 800, 900].includes(value)
      }
    }
  },
  methods: {
    onOk () {
      this.getContenteditableArea().blur()
    },
    getContent () {
      return this.getContenteditableArea().innerText
    },
    getContenteditableArea () {
      return this.$el.querySelector('.bcq-inline-editor-contenteditable')
    },
    onBlur (emitBlur = true) {
      this.contentEditable = false
      if (emitBlur) {
        this.$emit('blur', {
          content: this.getContent()
        })
      }
    },
    onEdit ($event) {
      if (this.editOn === $event.type && !this.readonly) {
        this.contentEditable = true
      }
    },
    onCancel () {
      this.getContenteditableArea().innerText = this.content
      this.onBlur(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/inline-editor/inline-editor.vue